import { Box, List, Stack } from "@mantine/core";
import style from "./privacy.module.css";
import { useTranslation } from "react-i18next";
import { PrivacyMenu } from "./privacy-menu";

export const GDPRPage = () => {
    const { t } = useTranslation(["privacy"]);
    
    return (
        <div className={style.wrapper}>
            <div className={style.innerWrapper}>
                <div className={style.contentWrapper}>
                    <Stack className={style.menuContent} spacing={"0.5rem"} mt={"10rem"}>
                        <PrivacyMenu />
                    </Stack>

                    <Box className={style.textContent} spacing={"0.5rem"} mt={"8rem"}>
                        <article>
                            <h1 className={style.header1}>{t("gdpr.title")}</h1>

                            <h2 className={style.header2}>{t("gdpr.info_title")}</h2>

                            <p>{t("gdpr.info_text1")}</p>

                            <br />
                            <p>{t("gdpr.info_text2")}</p>

                            <br />
                            <h2 className={style.header2}>{t("gdpr.commitment_title")}</h2>
                            <p>{t("gdpr.commitment_text1")}</p>
                            <br />
                            <p>{t("gdpr.commitment_text2")}</p>
                            <br />
                            <p>{t("gdpr.commitment_text3")}</p>
                            <br />
                            <p>{t("gdpr.commitment_text4")}</p>
                            <br />
                            <h2 className={style.header2}>{t("gdpr.requirements_title")}</h2>
                            <p>{t("gdpr.requirements_intro")}</p>
                            <List>
                                {t("gdpr.requirements_list", { returnObjects: true }).map((item, index) => (
                                    <List.Item key={index}>
                                        <p>{item}</p>
                                    </List.Item>
                                ))}
                            </List>
                        </article>
                    </Box>
                </div>
            </div>
        </div>
    );
};
